(function () {
  function initJournal(root) {
    const section = root.matches('.journal') ? root : root.querySelector('.journal');
    if (!section) return;

    const swiperEl = section.querySelector('.journal__swiper');
    if (!swiperEl || typeof Swiper === 'undefined') return;

    if (swiperEl.swiper) {
      swiperEl.swiper.destroy(true, true);
    }

    const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
    if (slideCount === 0) return;

    new Swiper(swiperEl, {
      slidesPerView: 1.2,
      spaceBetween: 22,
      speed: 500,
      grabCursor: true,
      breakpoints: {
        601: {
          slidesPerView: 2,
        },
        1026: {
          slidesPerView: 3,
        },
        1501: {
          slidesPerView: 4,
        },
      },
      navigation: {
        nextEl: section.querySelector('.journal__next'),
        prevEl: section.querySelector('.journal__prev'),
      },
    });
  }

  function initAll() {
    document.querySelectorAll('.journal').forEach(initJournal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initJournal(event.target);
  });
})();
